import { TableColumn } from '../../components/DataTable/TableColumn';
import { ProductSalesReport } from '../../interfaces/Report/ProductSalesReport/ProductSalesReport';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { partnerPlatformNameMap } from '../../constants/PartnerPlatform';
import { Period } from '../../interfaces/Period';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { getCreatedAtColumn } from '../SalesReport/SalesReportTable';

export const productSalesReportColumns: TableColumn<ProductSalesReport>[] = [
  {
    id: 'brand-name',
    name: 'Marka',
    accessor: (row) => <TextColumn value={row.brandName ?? ''} />,
  },
  {
    id: 'product-name',
    name: 'Ürün Adı',
    accessor: (row) => <TextColumn value={row.productName} />,
  },
  {
    id: 'option-value-name',
    name: 'Varyant',
    accessor: (row) => <TextColumn value={row.optionValueName ?? ''} />,
  },
  {
    id: 'platform',
    name: 'Platform',
    accessor: (row) => (
      <TextColumn value={partnerPlatformNameMap[row.platform]} />
    ),
  },
  {
    id: 'amount',
    name: 'Adet',
    accessor: (row) => <TextColumn value={row.amount.toString()} />,
  },
];

type ProductSalesReportTableProps = {
  rows: ProductSalesReport[];
  period?: Period;
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const ProductSalesReportTable = (
  props: ProductSalesReportTableProps,
) => (
  <DataTable
    columns={[getCreatedAtColumn(props.period), ...productSalesReportColumns]}
    totalCount={props.totalCount}
    rows={props.rows}
    limit={props.pagination.pageSize}
    setLimit={(newLimit) => props.onPagination({ page: 0, pageSize: newLimit })}
    page={props.pagination.page}
    setPage={(newPage) =>
      props.onPagination({ ...props.pagination, page: newPage })
    }
  />
);
